import { render, staticRenderFns } from "./UTableAnalytics.vue?vue&type=template&id=974c94ec&scoped=true&"
import script from "./UTableAnalytics.vue?vue&type=script&lang=js&"
export * from "./UTableAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974c94ec",
  null
  
)

export default component.exports